export const payButtonId = 'submitBtnId';
export const payButtonContainerId = 'submitBtnContainerId';
export const paymentNetworksId = 'paymentNetworksId';
